import React, { useState, useRef } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://v2.schmalgsicht.de';

export function MessageForm() {
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [placeholder, setPlaceholder] = useState('Deine Nachricht an Chris & Lena');
  const lastMessageRef = useRef('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate message
    if (message.trim() === '') {
      setPlaceholder('Die Nachricht darf nicht leer sein');
      setTimeout(() => {
        setPlaceholder('Deine Nachricht an Chris & Lena');
      }, 3000);
      return;
    }

    // Check for duplicate
    if (message.toLowerCase() === lastMessageRef.current.toLowerCase()) {
      return;
    }

    // Show loading state
    setIsLoading(true);
    lastMessageRef.current = message;

    try {
      // Send message to Flask API
      const response = await fetch(`${API_BASE_URL}/api/messages`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: [message] }),
      });

      const result = await response.json();

      if (result.status !== 'success') {
        throw new Error(result.message || 'Failed to send message');
      }

      // Success
      setMessage('');
      setPlaceholder('Danke für deine Nachricht!');

      setTimeout(() => {
        setPlaceholder('Deine Nachricht an Chris & Lena');
        setIsLoading(false);
      }, 4000);
    } catch (error) {
      setIsLoading(false);
      setPlaceholder('Fehler beim Senden. Bitte versuche es erneut.');
      setTimeout(() => {
        setPlaceholder('Deine Nachricht an Chris & Lena');
      }, 3000);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-2xl mx-auto">
      <div className="rounded-full transition-all duration-300">
        <div className="relative flex items-center rounded-full min-h-[2.5rem] bg-white overflow-hidden">
          {/* Input */}
          <input
            type="text"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder={placeholder}
            disabled={isLoading}
            className="flex-grow px-6 py-3 text-center text-sm sm:text-base md:text-lg font-normal text-gray-900 placeholder-gray-500 bg-transparent border-none outline-none disabled:opacity-50 relative z-10"
          />

        {isLoading ? (
          <div className="flex items-center justify-center px-4">
            <svg
              width="40px"
              height="40px"
              viewBox="0 0 100 100"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle fill="#1f2937" stroke="none" cx="6" cy="50" r="6">
                <animate
                  attributeName="opacity"
                  dur="1s"
                  values="0;1;0"
                  repeatCount="indefinite"
                  begin="0.1"
                />
              </circle>
              <circle fill="#1f2937" stroke="none" cx="26" cy="50" r="6">
                <animate
                  attributeName="opacity"
                  dur="1s"
                  values="0;1;0"
                  repeatCount="indefinite"
                  begin="0.2"
                />
              </circle>
              <circle fill="#1f2937" stroke="none" cx="46" cy="50" r="6">
                <animate
                  attributeName="opacity"
                  dur="1s"
                  values="0;1;0"
                  repeatCount="indefinite"
                  begin="0.3"
                />
              </circle>
            </svg>
          </div>
        ) : (
          <button
            type="submit"
            className="mr-2 w-8 h-8 sm:w-10 sm:h-10 bg-gray-900 rounded-full border-none cursor-pointer transition-all duration-300 hover:bg-gray-700 hover:scale-110 flex items-center justify-center"
          >
            <svg
              className="w-4 h-4 sm:w-5 sm:h-5"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 12H18M18 12L13 7M18 12L13 17"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
        </div>
      </div>
    </form>
  );
}
